import { jsx } from "react/jsx-runtime";
import DateTime from "../../../../external/luxon/src/datetime.js";
import "../../../../external/luxon/src/duration.js";
import Settings from "../../../../external/luxon/src/settings.js";
import { useMemo, useState, useRef, useEffect } from "react";
import { DatesSelector } from "./DatesSelector.js";
import { DatePickerContext } from "./context/DatePickerContext.js";
import { DatePickerContextActions } from "./context/DatePickerContextActions.js";
import { DEFAULT_YEAR_RANGE } from "../../constants.js";
import { createEvent } from "../../../../utils/createEvent.js";
const DatePicker = ({
  onChange,
  monthDate,
  name,
  value,
  locale = "en-US",
  yearTo,
  yearFrom,
  disabledFrom,
  disabledTo,
  readonly
}) => {
  var _a;
  Settings.defaultLocale = locale;
  const ctx = useMemo(() => ({
    selected: value ? [value, void 0] : [void 0, void 0],
    current: null,
    yearRange: yearFrom && yearTo ? [yearFrom, yearTo] : DEFAULT_YEAR_RANGE,
    disabledTo,
    disabledFrom,
    readonly
  }), [disabledFrom, disabledTo, readonly, value, yearFrom, yearTo]), [selectedMonth, setSelectedMonth] = useState(
    monthDate || ((_a = ctx.selected) == null ? void 0 : _a[0]) || DateTime.now().toISODate()
  ), actionsDataRef = useRef({
    value,
    onChange
  });
  actionsDataRef.current = {
    value,
    onChange
  }, useEffect(() => {
    monthDate && setSelectedMonth(monthDate);
  }, [monthDate]);
  const contextActions = useMemo(() => ({
    onDateClick: (newDate) => {
      if (!newDate) return;
      const { value: value2, onChange: onChange2 } = actionsDataRef.current;
      newDate !== value2 && (onChange2 == null || onChange2(createEvent({ name, value: newDate })));
    },
    onPrev: () => {
      setSelectedMonth((prev) => DateTime.fromISO(prev).minus({ month: 1 }).toISODate());
    },
    onNext: () => {
      setSelectedMonth((prev) => DateTime.fromISO(prev).plus({ month: 1 }).toISODate());
    },
    onMonthChanged: (date) => {
      setSelectedMonth(date);
    }
  }), [name]);
  return /* @__PURE__ */ jsx(DatePickerContextActions.Provider, { value: contextActions, children: /* @__PURE__ */ jsx(DatePickerContext.Provider, { value: ctx, children: /* @__PURE__ */ jsx(DatesSelector, { monthDate: selectedMonth }) }) });
};
export {
  DatePicker
};
//# sourceMappingURL=DatePicker.js.map
